import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';

import type {
  SendRemindersInput,
  SendRemindersResultDto,
} from '@/api/reminders-client';
import { useRemindersClient } from '@/api/reminders-client-context';

// =============================================================================
// use-reminders.ts — Hook TanStack Mutation de la RELANCE MANUELLE admin (A-16).
// =============================================================================
// Une seule commande (useMutation) — l'admin DÉCLENCHE la relance (effet de bord serveur : relais INFRA →
// worker). Le client effectif vient du RemindersClientProvider (doublable, stub-first). ZÉRO règle métier ici :
// l'autorité (RBAC AdminSessionGuard, résolution de cohorte, filtrage des non-soumis sous withTenant, Postmark
// CCI, DE.ReminderSent) est l'API/worker. Après une relance, on INVALIDE le suivi fournisseurs pour refléter la
// « dernière relance » mise à jour côté serveur (rafraîchissement asynchrone du read-model).

/** Commande de relance manuelle (individuelle / groupée / SIREN). Invalide le suivi fournisseurs au succès. */
export function useSendReminders(
  campaignId: string,
): UseMutationResult<SendRemindersResultDto, Error, SendRemindersInput> {
  const client = useRemindersClient();
  const queryClient = useQueryClient();
  return useMutation<SendRemindersResultDto, Error, SendRemindersInput>({
    mutationFn: (input: SendRemindersInput) => client.sendReminders(input),
    onSuccess: () => {
      // Le read-model « Suivi fournisseurs » porte la colonne « dernière relance » — on l'invalide pour que
      // le prochain rendu reflète l'état serveur (le worker journalise campaign_relance_log de façon async).
      void queryClient.invalidateQueries({
        queryKey: ['supplier-monitoring', campaignId],
      });
    },
  });
}
